import React from "react";
import "./header.css"
import { ImFacebook, ImInstagram, ImTwitter } from "react-icons/im";

const Header = () => {
    return (
        <div className="header">
            <h1>Corinne Beenfield</h1>
            
            <div className="header-links">
                <div className="header-icon">
                <a href="https://www.facebook.com/corinne.beenfield.58" target="_blank" rel="noreferrer">
                <ImFacebook size="1.5em" color="#919191" />
                </a>
                </div>
                <div className ="header-icon">
                <a href="https://www.instagram.com/corinne_beenfield/?hl=en" target="_blank" rel="noreferrer">
                <ImInstagram size="1.5em" color="#919191" />
                </a>
                </div>
                <div className="header-icon">
                <a href="https://twitter.com/cbeenfield" target="_blank" rel="noreferrer">
                <ImTwitter size="1.5em" color="#919191" />
                </a>
                </div>
            </div>
        
        
            
        </div>
    )
}
export default Header;